export const nlITSupport = {
  title: "Professionele IT Onderhoudsdiensten",
  description: "Uitgebreide IT-onderhoudsoplossingen om uw bedrijf soepel te laten draaien met betrouwbare technische ondersteuning en proactief onderhoud.",
  subtitle: "IT Onderhoudsoplossingen",

  maintenanceTitle: "Onze IT Onderhoudsdiensten",
  maintenanceSubtitle: "Proactief en reactief onderhoud voor systeem betrouwbaarheid",
  offersTitle: "Serviceopties",

  maintenanceServices: {
    preventive: {
      title: "Preventief Onderhoud",
      subtitle: "Proactieve zorg om problemen te voorkomen voordat ze zich voordoen",
      services: [
        "Regelmatige updates van software en besturingssystemen",
        "Controleren en updaten van antivirus, firewalls en beveiligingsoplossingen",
        "Werkplekken schoonmaken (tijdelijke bestanden, optimalisatie)",
        "Regelmatig back-ups maken van gegevens"
      ]
    },
    corrective: {
      title: "Correctief Onderhoud",
      subtitle: "Snelle oplossing van bestaande technische problemen",
      services: [
        "Probleemoplossing bij hardware- of softwarestoringen",
        "Herinstalleren of repareren van beschadigde systemen",
        "Verwijderen van virussen, malware of ongewenste programma's"
      ]
    },
    adaptive: {
      title: "Adaptief/Evolutionair Onderhoud",
      subtitle: "Uw systemen up-to-date houden met technologische ontwikkelingen",
      services: [
        "Nieuwe functies toevoegen aan software of systemen",
        "Migreren naar nieuwere technologieën (cloud, servers, netwerken)",
        "Hardwarecapaciteit upgraden (RAM, harde schijven, SSD, enz.)"
      ]
    },
    predictive: {
      title: "Voorspellend Onderhoud",
      subtitle: "Geavanceerde monitoring om problemen te anticiperen en te voorkomen",
      services: [
        "Proactieve monitoring met gespecialiseerde tools",
        "Storingen anticiperen door prestatieanalyse"
      ],
      offers: [
        "Maandelijkse of jaarlijkse contracten (onbeperkte ondersteuning)",
        "Probleemoplossing op aanvraag",
        "Remote of on-site ondersteuning"
      ]
    }
  },

  processTitle: "Ons Onderhoudsproces",
  processSteps: [
    {
      title: "Systeemevaluatie",
      description: "Uitgebreide analyse van uw huidige IT-infrastructuur en onderhoudsbehoeften."
    },
    {
      title: "Onderhoudsplanning",
      description: "Ontwikkelen van een aangepast onderhoudsschema afgestemd op uw bedrijfsbehoeften."
    },
    {
      title: "Proactieve Implementatie",
      description: "Uitvoeren van preventieve maatregelen om potentiële systeemproblemen te voorkomen."
    },
    {
      title: "Continue Monitoring",
      description: "Voortdurende bewaking van systeemprestaties en beveiligingsindicatoren."
    },
    {
      title: "Snelle Respons",
      description: "Snelle oplossing van eventuele problemen ondanks preventieve maatregelen."
    },
    {
      title: "Prestatie Rapportage",
      description: "Gedetailleerde rapportage over systeemgezondheid, onderhoudsactiviteiten en aanbevelingen."
    }
  ]
};

export const deITSupport = {
  title: "Professionelle IT-Wartungsdienste",
  description: "Umfassende IT-Wartungslösungen, damit Ihr Unternehmen reibungslos läuft – mit zuverlässigem technischen Support und proaktiver Wartung.",
  subtitle: "IT-Wartungslösungen",

  maintenanceTitle: "Unsere IT-Wartungsdienste",
  maintenanceSubtitle: "Proaktive und reaktive Wartung für Systemzuverlässigkeit",
  offersTitle: "Serviceoptionen",

  maintenanceServices: {
    preventive: {
      title: "Präventive Wartung",
      subtitle: "Proaktive Pflege zur Vermeidung von Problemen, bevor sie auftreten",
      services: [
        "Regelmäßige Updates von Software und Betriebssystemen",
        "Überprüfung und Aktualisierung von Antivirus, Firewalls und Sicherheitslösungen",
        "Reinigung von Arbeitsplätzen (temporäre Dateien, Optimierung)",
        "Regelmäßige Datensicherungen durchführen"
      ]
    },
    corrective: {
      title: "Korrektive Wartung",
      subtitle: "Schnelle Behebung bestehender technischer Probleme",
      services: [
        "Fehlerbehebung bei Hardware- oder Softwareausfällen",
        "Neuinstallation oder Reparatur beschädigter Systeme",
        "Entfernung von Viren, Malware oder unerwünschten Programmen"
      ]
    },
    adaptive: {
      title: "Adaptive/Evolutionäre Wartung",
      subtitle: "Ihre Systeme mit technologischen Fortschritten aktuell halten",
      services: [
        "Neue Funktionen zu Software oder Systemen hinzufügen",
        "Migration zu neueren Technologien (Cloud, Server, Netzwerke)",
        "Hardwarekapazität erweitern (RAM, Festplatten, SSD usw.)"
      ]
    },
    predictive: {
      title: "Prädiktive Wartung",
      subtitle: "Fortschrittliche Überwachung zur Vorhersage und Vermeidung von Problemen",
      services: [
        "Proaktive Überwachung mit spezialisierten Tools",
        "Fehler antizipieren durch Leistungsanalyse"
      ],
      offers: [
        "Monatliche oder jährliche Verträge (unbegrenzter Support)",
        "Störungsbehebung auf Abruf",
        "Remote- oder Vor-Ort-Support"
      ]
    }
  },

  processTitle: "Unser Wartungsprozess",
  processSteps: [
    {
      title: "Systembewertung",
      description: "Umfassende Analyse Ihrer aktuellen IT-Infrastruktur und Wartungsanforderungen."
    },
    {
      title: "Wartungsplanung",
      description: "Entwicklung eines individuellen Wartungsplans, abgestimmt auf Ihre Geschäftsanforderungen."
    },
    {
      title: "Proaktive Umsetzung",
      description: "Durchführung präventiver Maßnahmen zur Vermeidung potenzieller Systemprobleme."
    },
    {
      title: "Kontinuierliche Überwachung",
      description: "Laufende Überwachung der Systemleistung und Sicherheitsindikatoren."
    },
    {
      title: "Schnelle Reaktion",
      description: "Schnelle Behebung aller Probleme, die trotz präventiver Maßnahmen auftreten."
    },
    {
      title: "Leistungsbericht",
      description: "Detaillierte Berichte über Systemzustand, Wartungsaktivitäten und Empfehlungen."
    }
  ]
};
export const enITSupport = {
  // Hero Section
  title: "Professional IT Maintenance Services",
  description: "Comprehensive IT maintenance solutions to keep your business running smoothly with reliable technical support and proactive maintenance.",
  subtitle: "IT Maintenance Solutions",

  // Maintenance Services Section
  maintenanceTitle: "Our IT Maintenance Services",
  maintenanceSubtitle: "Proactive and reactive maintenance to ensure system reliability",
  offersTitle: "Service Options",

  // Maintenance Services
  maintenanceServices: {
    preventive: {
      title: "Preventive Maintenance",
      subtitle: "Proactive care to prevent issues before they occur",
      services: [
        "Regular updates of software and operating systems",
        "Checking and updating antivirus, firewalls, and security solutions",
        "Cleaning workstations (temporary files, optimization)",
        "Performing regular data backups"
      ]
    },
    corrective: {
      title: "Corrective Maintenance",
      subtitle: "Quick resolution of existing technical issues",
      services: [
        "Troubleshooting in case of hardware or software failures",
        "Reinstalling or repairing damaged systems",
        "Removing viruses, malware, or unwanted programs"
      ]
    },
    adaptive: {
      title: "Adaptive/Evolutionary Maintenance",
      subtitle: "Keeping your systems current with technology advancements",
      services: [
        "Adding new features to software or systems",
        "Migrating to newer technologies (cloud, servers, networks)",
        "Upgrading hardware capacity (RAM, hard drives, SSD, etc.)"
      ]
    },
    predictive: {
      title: "Predictive Maintenance",
      subtitle: "Advanced monitoring to anticipate and prevent issues",
      services: [
        "Proactive monitoring using specialized tools",
        "Anticipating failures through performance analysis"
      ],
      offers: [
        "Monthly or annual contracts (unlimited support)",
        "On-demand troubleshooting services",
        "Remote or on-site support"
      ]
    }
  },

  // Process Section
  processTitle: "Our Maintenance Process",
  processSteps: [
    {
      title: "System Assessment",
      description: "Comprehensive analysis of your current IT infrastructure and maintenance needs."
    },
    {
      title: "Maintenance Planning",
      description: "Developing a customized maintenance schedule tailored to your business requirements."
    },
    {
      title: "Proactive Implementation",
      description: "Executing preventive measures to avoid potential system issues."
    },
    {
      title: "Continuous Monitoring",
      description: "Ongoing surveillance of system performance and security indicators."
    },
    {
      title: "Rapid Response",
      description: "Quick resolution of any issues that arise despite preventive measures."
    },
    {
      title: "Performance Reporting",
      description: "Detailed reporting on system health, maintenance activities, and recommendations."
    }
  ]
};

export const frITSupport = {
  // Hero Section
  title: "Services Professionnels de Maintenance IT",
  description: "Solutions complètes de maintenance informatique pour maintenir le bon fonctionnement de votre entreprise avec un support technique fiable et une maintenance proactive.",
  subtitle: "Solutions de Maintenance IT",

  // Maintenance Services Section
  maintenanceTitle: "Nos Services de Maintenance IT",
  maintenanceSubtitle: "Maintenance proactive et réactive pour assurer la fiabilité du système",
  offersTitle: "Options de Service",

  // Maintenance Services
  maintenanceServices: {
    preventive: {
      title: "Maintenance Préventive",
      subtitle: "Soins proactifs pour prévenir les problèmes avant qu'ils ne surviennent",
      services: [
        "Mises à jour régulières des logiciels et systèmes d'exploitation",
        "Vérification et mise à jour des antivirus, pare-feux et solutions de sécurité",
        "Nettoyage des postes de travail (fichiers temporaires, optimisation)",
        "Réalisation de sauvegardes régulières des données"
      ]
    },
    corrective: {
      title: "Maintenance Corrective",
      subtitle: "Résolution rapide des problèmes techniques existants",
      services: [
        "Dépannage en cas de défaillances matérielles ou logicielles",
        "Réinstallation ou réparation des systèmes endommagés",
        "Suppression des virus, logiciels malveillants ou programmes indésirables"
      ]
    },
    adaptive: {
      title: "Maintenance Adaptive/Évolutive",
      subtitle: "Maintenir vos systèmes à jour avec les avancées technologiques",
      services: [
        "Ajout de nouvelles fonctionnalités aux logiciels ou systèmes",
        "Migration vers des technologies plus récentes (cloud, serveurs, réseaux)",
        "Mise à niveau de la capacité matérielle (RAM, disques durs, SSD, etc.)"
      ]
    },
    predictive: {
      title: "Maintenance Prédictive",
      subtitle: "Surveillance avancée pour anticiper et prévenir les problèmes",
      services: [
        "Surveillance proactive à l'aide d'outils spécialisés",
        "Anticipation des défaillances par analyse des performances"
      ],
      offers: [
        "Contrats mensuels ou annuels (support illimité)",
        "Services de dépannage à la demande",
        "Support à distance ou sur site"
      ]
    }
  },

  // Process Section
  processTitle: "Notre Processus de Maintenance",
  processSteps: [
    {
      title: "Évaluation du Système",
      description: "Analyse complète de votre infrastructure informatique actuelle et de vos besoins de maintenance."
    },
    {
      title: "Planification de la Maintenance",
      description: "Élaboration d'un calendrier de maintenance personnalisé adapté à vos besoins professionnels."
    },
    {
      title: "Mise en Œuvre Proactive",
      description: "Exécution de mesures préventives pour éviter les problèmes système potentiels."
    },
    {
      title: "Surveillance Continue",
      description: "Surveillance permanente des performances du système et des indicateurs de sécurité."
    },
    {
      title: "Intervention Rapide",
      description: "Résolution rapide de tout problème survenant malgré les mesures préventives."
    },
    {
      title: "Rapport de Performance",
      description: "Reporting détaillé sur l'état du système, les activités de maintenance et les recommandations."
    }
  ]
};